import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  useTheme,
} from '@mui/material';

export type GenerateReportDialogProps = {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
  text?: string;
};

function ResetToDefaultsDialog({
  open,
  onClose,
  onSuccess,
  text,
}: GenerateReportDialogProps) {
  const theme = useTheme();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        sx: { borderRadius: '10px', padding: '16px', width: '500px' },
      }}
    >
      <DialogTitle
        id="alert-dialog-title"
        sx={{
          verticalAlign: 'left',
          display: 'flex',
        }}
      >
        <Typography
          sx={{
            margin: 0,
            alignSelf: 'self-end',
            fontSize: '28px',
            fontWeight: 700,
            color: 'warning.main',
          }}
        >
          Modify plan?
        </Typography>
      </DialogTitle>

      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          sx={{ color: '#525F81', fontWeight: 400 }}
        >
          <Typography>
            You have changed plan settings. This will clear all the data in the
            forms and you will not be able to bring it back.
          </Typography>

          <Typography>Proceed?</Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ gap: '1rem' }}>
        <Button
          onClick={onClose}
          size="large"
          variant="text"
          sx={{
            backgroundColor: '#0000330F',
            width: '100px',
            borderRadius: '5px',
            color: '#60646C',
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            onSuccess();
            onClose();
          }}
          variant="contained"
          size="large"
          sx={{
            backgroundColor: 'warning.contrastText',
            width: '100px',
            borderRadius: '5px',
          }}
        >
          Proceed
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ResetToDefaultsDialog;
